
<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{tituloGrid}}</span>
      </v-col>
    </v-row>
    <v-row class="no-gutters">
    <v-col md="12" sm="12" class="pa-0 ma-0">
      <v-tabs v-model="nTabSelect" align-with-title dark active-class="active-item" background-color="#161E33" class="mt-1" height="36px">
        <v-tabs-slider color="btndest lighten-3"></v-tabs-slider>
        <v-tab v-for="nameTab in aInfoTab" :key="nameTab.nombre" dark>
            <v-icon left small>{{nameTab.icono}}</v-icon>
          {{nameTab.nombre}} 
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="nTabSelect">
       <grid ref="GridPrincipal"
          v-if="this.$store.state.token!=''"
          :key="nRefresGrid"
          :tabla="aTablaName[[nTabSelect]]"
          :bActiveFilter="true"
          :bActiveExport="true"
          :bSingleSelect="true"
          :bShowSelect="false"
          :sIdTable="aIdTable[nTabSelect]"
          :bShowMapDetails="false"
          :bActiveNew="true"
          altoTabla="48vh">
        </grid>
      </v-tabs-items>
    </v-col>
    </v-row>
  </v-container>  

</template>

<script>
import grid from '@/components/Grid/Grid.vue'

export default {
  name:"ClasificacionPQR",
  components: {
    grid,
  },
  data() {
    return {
      aInfoTab   : [
        {
            nombre:'Tipos de requerimientos',
            icono:'mdi-file-document-multiple',
        },
        {
            nombre:'Tipos de cliente',
            icono:'mdi-account-group',
        },
        {
            nombre:'Medio de recepción',
            icono:'mdi-tablet-cellphone',
        }
    ],
      nTabSelect : 0,
      aTablaName  : ['PQR_Tipos_requerimiento', 'PQR_Tipos_Cliente', 'PQR_Atempi_medio_recepcion'],
      aIdTable    : ['IDTipo', 'idTipo', 'idPQR_Atempi_medio_recepcion'],
      nRefresGrid : 0,
      tituloGrid: 'Clasificación PQR'
    }
  },
  methods: {
  },
  watch: {
    nTabSelect(){
      this.nRefresGrid++
    }
  },
}
</script>

<style lang="scss" scoped>

</style>